import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./channels"

import $ from "jquery"
window.$ = window.jQuery = $

import "bootstrap"
import "bootstrap-select/dist/js/bootstrap-select.js"

import flatpickr from "flatpickr"

import "./payment"
import "./suspension_length"
import "./reorder_fights"
import "./organization_form"
import "./event_user"
import "./event_organization"
import "./print_card"
import "./fight_form"

import "./controllers"

// support direct file uploads
ActiveStorage.start()

document.addEventListener("turbo:load", () => {
  flatpickr(".datepicker", { altInput: true, altFormat: "m/d/Y", dateFormat: "Y-m-d", allowInput: true })

  $("[data-action=refreshPage]").on("click", () => window.location.reload())
})
